// Asks the server for the next free card number (100001, 100002, ...). The server skips any
// number a member, employee or walk-in already holds, so a generated card never matches anyone's.
// Resolves to "" if the server can't be reached; the field is then left blank for the user to fill in.
export const generateCardNumber = async () => {
  try {
    const { token } = JSON.parse(localStorage.getItem("userdata") || "{}");
    const response = await fetch(`${window.constants.api_url}/card-number/next`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    });
    const res = await response.json();
    return res && res.card_number ? String(res.card_number) : "";
  } catch (e) {
    return "";
  }
};
